import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { ArrayHelper } from '../../../models/helpers/array-helper';
import { ConfirmDeleteModalComponent } from '../../core/components/delete-modal/confirm-delete-modal-component';
import { CustomerService } from '../../core/services/customer.service';
export class CustomersComponent {
    constructor(route, customerService, router, appConfigService) {
        this.route = route;
        this.customerService = customerService;
        this.router = router;
        this.appConfigService = appConfigService;
        this.scrollConfig = {
            suppressScrollX: false,
            suppressScrollY: true
        };
        this.columns = [
            { title: 'ID', property: c => c.code, canSort: true },
            { title: 'Name', property: c => c.name, canSort: true },
            { title: 'Type', property: c => c.customerType, canSort: true },
            { title: 'Country', property: c => c.country, canSort: true },
            { title: 'Logo', property: c => c.logo && c.logo.id },
        ];
        this.sortColumn = this.columns[0];
        this.sortAsc = true;
        this.page = 1;
    }
    ngOnInit() {
        this.pageSize = this.appConfigService.customerListPageSize;
        this.route.data.subscribe(data => {
            this.customers = data.customers || [];
            this.filterUpdated();
        });
        this.router.events.subscribe((evt) => {
            if (!(evt instanceof NavigationEnd)) {
                return;
            }
            window.scrollTo(0, 0);
        });
    }
    filterUpdated() {
        let searchText = this.searchText ? this.searchText.toLowerCase() : '';
        this.filteredCustomers = this.customers.filter(customer => {
            if (searchText === '')
                return true;
            if (customer.certificateCodes
                && customer.certificateCodes.some(code => code.toLowerCase().includes(searchText)))
                return true;
            return (customer.name && customer.name.toLowerCase().includes(searchText));
        });
        this.sort();
    }
    sort(column) {
        if (column && !column.canSort)
            return;
        if (column === this.sortColumn)
            this.sortAsc = !this.sortAsc;
        if (column)
            this.sortColumn = column;
        this.filteredCustomers = ArrayHelper.sortBy(this.filteredCustomers, this.sortAsc, this.sortColumn.property);
        this.pageChange(this.page);
    }
    pageChange(page) {
        this.page = page;
        let start = this.pageSize * (page - 1);
        let end = this.pageSize * page;
        this.pageCustomers = this.filteredCustomers.slice(start, end);
    }
    showDeleteConfirmModal(customer) {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            let result = yield this.confirmDeleteModal.showAwait();
            if (result) {
                yield this.customerService.deleteCustomer(customer.id);
                this.customers = yield this.customerService.getCustomers();
                this.filterUpdated();
            }
        });
    }
    updatePageSize() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield this.appConfigService.updateCustomerPageSize(this.pageSize);
            setTimeout(() => {
                this.page = 1;
                this.pageChange(this.page);
                this.filterUpdated();
            });
        });
    }
}
